import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../_metronic/_partials/controls";
import { useLibraryUIContext } from "./LibraryUIContext";
import { createLibraryFile, fetchFiles, fetchLibrarys } from "../_redux/libraryAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import LibraryGrid from "./library-grid/LibraryGrid";
import LibraryUploadFile from "./library-upload-file/LibraryUploadFile";
import { toast } from "react-toastify";
import { toastOption } from "../../../../_metronic/_helpers";


export const LibraryCard = ({
  match: {
    params: { id }
  },
  history
}) => {
  // * DECLARE HOOKS
  const dispatch = useDispatch();

  // * Library UI Context
  const libraryUIContext = useLibraryUIContext();
  const libraryUIProps = useMemo(() => {
    return {
      queryParams: libraryUIContext.queryParams,
      setQueryParams: libraryUIContext.setQueryParams,
      openEditLibraryPage: libraryUIContext.openEditLibraryPage,
      openLibraryFilePage: libraryUIContext.openLibraryFilePage
    };
  }, [libraryUIContext]);

  // * Getting curret state of library list from store (Redux)
  const { entities, listLoading, actionsLoading, libraryFiles } = useSelector(
    state => state.organizationLibrary,
    shallowEqual
  );

  useEffect(() => {
    // * Requset ke Library Action
    if (id) {
      dispatch(
        fetchLibrarys({
          parent_uuid: id
        })
      );
      dispatch(fetchFiles({ library_folder_uuid: id }));
    } else {
      dispatch(fetchLibrarys(libraryUIProps.queryParams));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [libraryUIProps.queryParams, dispatch]);

   // * UPLOAD FILE
   const onSubmitCreateFile = value => {
    const formData = new FormData();
    formData.append("name", value.name);
    formData.append("file", value.file);
    formData.append("library_folder_uuid", id);
    dispatch(createLibraryFile(formData))
      .then(res => {
        toast.success(res.data.message, toastOption);
        if (id) {
          dispatch(
            fetchLibrarys({
              filter: { ...libraryUIProps.queryParams.filter },
              parent_uuid: id
            })
          );
          dispatch(fetchFiles({ library_folder_uuid: id }));
        } else {
          dispatch(fetchLibrarys(libraryUIProps.queryParams));
        }
        setOpenModal(prev => ({ ...prev, uploadFile: false }));
        setCurrentItem({});
      })
      .catch(err => {
        toast.error(`Only JPG, JPEG, PNG, PDFs, Excel files, and PPTs are allowed`);
      });
  };

  const [data, setData] = useState([]);
  let fileSharing = data.filter(v => v.check_sharing === true && v.uuid === id);

  const [currentItem, setCurrentItem] = useState({});
  const [openModal, setOpenModal] = useState({
    uploadFile: false
  });

  useEffect(() => {
    if (data.length <= 0) {
      setData(entities);
    }

  }, [data, entities])


  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      {/* UPLOAD FILE MODAL */}
      <LibraryUploadFile
        show={openModal.uploadFile}
        onHide={() => {
          setOpenModal(prev => ({ ...prev, uploadFile: false }));
          setCurrentItem({});
        }}
        onSubmit={onSubmitCreateFile}
        defaultValues={currentItem}
      />
      <Card>
        <CardHeader title="Library">
          <CardHeaderToolbar>
            {fileSharing?.length > 0 && (
                  <button
                    type="button"
                    className="btn mx-1 btn-outline-primary"
                    onClick={() => 
                      setOpenModal(prev => ({ ...prev, uploadFile: true }))
                    }
                  >
                    Upload File
                  </button>
            )}
            {id  && (
              <button
                type="button"
                className="btn mx-1 btn-secondary"
                onClick={() => history.goBack()}
              >
                Kembali
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <LibraryGrid
            id={id}
            folders={entities}
            files={libraryFiles}
            openEditLibraryPage={libraryUIProps.openEditLibraryPage}
          />
        </CardBody>
      </Card>
    </>
  );
};
